import React, { useState } from "react";
import JSONPretty from "react-json-pretty";
import "react-json-pretty/themes/monikai.css"; // Optional: Use a theme
import { toast, ToastContainer } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
const FAQPageSchemaForm = () => {
  const [faqList, setFaqList] = useState([{ question: "", answer: "" }]);
  const [schema, setSchema] = useState({
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "What is FAQ Schema?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "FAQ Schema helps improve SEO by marking up questions and answers.",
        },
      },
      {
        "@type": "Question",
        "name": "How to use this generator?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Fill in the questions and answers, then click Generate Schema.",
        },
      },
    ],
  });

  const handleFaqChange = (index, field, value) => {
    const updatedFaqList = faqList.map((faq, i) =>
      i === index ? { ...faq, [field]: value } : faq
    );
    setFaqList(updatedFaqList);
  };

  const addQuestion = () => {
    setFaqList([...faqList, { question: "", answer: "" }]);
  };

  const removeQuestion = (index) => {
    setFaqList(faqList.filter((_, i) => i !== index));
  };

  const generateSchema = () => {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqList.map((faq) => ({
        "@type": "Question",
        "name": faq.question || "Default Question",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faq.answer || "Default Answer",
        },
      })),
    };
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSchema(generateSchema());
  };

  const copySchema = () => {
    const schemaString = JSON.stringify(schema, null, 2);
    navigator.clipboard.writeText(schemaString).then(() => {
      alert("Schema copied to clipboard!");
    });
  };
  const deleteSchema = () => {
    setSchema({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What is FAQ Schema?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "FAQ Schema helps improve SEO by marking up questions and answers.",
          },
        },
        {
          "@type": "Question",
          "name": "How to use this generator?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Fill in the questions and answers, then click Generate Schema.",
          },
        },
      ],
    });
    toast.warning("Schema reset to dummy data!");
  };
  return (
    <div className="container mt-4">
      <ToastContainer/>
    
      <div className="row">
        <div className="col-md-6">
          <h5>Form</h5>
          <form onSubmit={handleSubmit} className="card p-4 shadow-sm">
            {faqList.map((faq, index) => (
              <div key={index} className="row mb-3 align-items-end">
                <div className="col-md-12 w-100">
                  <label className="form-label">Question #{index + 1}</label>
                  <input
                    type="text"
                    className="form-control"
                    value={faq.question}
                    onChange={(e) =>
                      handleFaqChange(index, "question", e.target.value)
                    }
                    placeholder="Enter question"
                  />
                </div>
                <div className="col-md-12">
                  <label className="form-label">Answer</label>
                  <textarea
                    className="form-control"
                    value={faq.answer}
                    onChange={(e) =>
                      handleFaqChange(index, "answer", e.target.value)
                    }
                    placeholder="Enter answer"
                    rows="3"
                  ></textarea>
                </div>
                <div className="col-md-2 text-end">
                  {index > 0 && (
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => removeQuestion(index)}
                    >
                      ✖
                    </button>
                  )}
                </div>
              </div>
            ))}

            <button
              type="button"
              className="btn btn-primary mb-3"
              onClick={addQuestion}
            >
              + Add Question
            </button>

            <button type="submit" className="btn btn-success w-100">
              Generate Schema
            </button>
          </form>
        </div>
        <div className="col-md-6">
          {/* JSON-LD Preview */}
          <div className="mt-3">
            <h5>Generated JSON-LD:</h5>
            <div className="d-flex justify-content-center align-items-center mb-3 mt-3">
  <button className="btn btn-primary me-2" onClick={copySchema}>
    Copy
  </button>
  <button className="btn btn-danger me-2" onClick={deleteSchema}>
    Reset
  </button>
  <button className="btn btn-info me-2">
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none text-white"
      href="https://developers.google.com/search/docs/appearance/structured-data"
    >
      Validate
    </a>
  </button>
  <button className="btn btn-success">
    <a
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-none text-white"
      href="https://search.google.com/test/rich-results"
    >
      Test
    </a>
  </button>
</div>
            <JSONPretty
              className="bg-light p-3 rounded border"
              data={schema}
            ></JSONPretty>
           
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQPageSchemaForm;
